<template>
    <div class="swiper-container">
        <div class="swiper main-links-carousel">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(block, index) in homeBlocks" :key="'home-block-' + index">
                    <a target="_top" :href="block.link.url" class="card rounded-0">
                        <div class="card-img-top" :style="{ backgroundImage: getImageUrl(block.image.urls[0]) }">
                            <img :src="getImageUrl(block.image.urls[0])" alt="" />
                        </div>
                        <span class="card-body">
                            <span class="card-text">
                                {{block.blurb ? block.blurb : "\n\r"}}
                            </span>
                            <span class="btn chevron-right-icon text-uppercase mt-3">{{block.link.text}}</span>
                        </span>
                    </a>
                </div>
            </div>
        </div>
        <div class="swiper-button-next swiper-navigation-yellow"></div>
        <div class="swiper-button-prev swiper-navigation-yellow"></div>
    </div>
</template>

<script>
    import gql from 'graphql-tag';
    import Swiper from 'swiper';
    import SwiperCore, { Navigation, Pagination } from 'swiper/core';
    SwiperCore.use([Navigation, Pagination]);

    export default {
        data() {
            return {
                swiper: null,
                homeBlocks: [],
                cmsBaseUrl: process.env.VUE_APP_CMS_BASE_URL,
            }
        },
        computed: {
            getHomeBlocks() {
                return this.blockCollection[0].blocks.contentItems;
            },
        },
        watch: {
            blockCollection: {
                handler() {
                    this.homeBlocks = this.getHomeBlocks;
                    this.$nextTick(() => {
                        this.swiperInnit();
                    })
                }
            }
        },
        apollo: {
            blockCollection: {
                query: gql`
                    {
                      blockCollection(where: {displayText: "Home Page Blocks"}) {
                        blocks {
                          contentItems {
                            ... on BlockSingle {
                              blurb
                              image {
                                urls
                              }
                              link {
                                text
                                url
                              }
                            }
                          }
                        }
                      }
                    }
                `,
            }
        },
        methods: {
            swiperInnit() {
                this.swiper = new Swiper(".main-links-carousel", {
                    slidesPerView: "auto",
                    spaceBetween: 30,
                    navigation: {
                        nextEl: "#HomeMainLinks .swiper-button-next",
                        prevEl: "#HomeMainLinks .swiper-button-prev",
                    },
                    breakpoints: {
                        992: {
                            slidesPerView: 3,
                            spaceBetween: 72,
                        },
                        1200: {
                            slidesPerView: 4,
                            spaceBetween: 30,
                        }
                    }
                });
            },
            getBaseUrl() {
                var IS_STAG = window.location.host.indexOf("inprogress") > -1 || window.location.host.indexOf("localhost") > -1;
                if (IS_STAG) this.cmsBaseUrl = 'https://dunloptyres-oc-qa.azurewebsites.net';

                return this.cmsBaseUrl;
            },
            getImageUrl(imagePath) {
                var fullPath = this.getBaseUrl() + imagePath;
                return fullPath;
            }
        },
    };
</script>